import { render, staticRenderFns } from "./error.vue?vue&type=template&id=82fc896c&scoped=true&"
var script = {}
import style0 from "./error.vue?vue&type=style&index=0&id=82fc896c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82fc896c",
  null
  
)

export default component.exports